// const unitNameRex = 'question|identity|course'
const unitNameRex = 'question|identity'
const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/user/login.vue'),
    meta: { title: '登录' },
  },
  {
    path: '/empty/content',
    name: 'emptyContent',
    component: () => import('../views/empty/content.vue'),
  },
  {
    path: '/login/reset',
    name: 'loginReset',
    component: () => import('../views/user/login-reset.vue'),
    meta: { title: '重置密码' },
  },
  {
    path: '/login/register',
    name: 'loginRegister',
    component: () => import('../views/user/login-register.vue'),
    meta: { title: '完善资料' },
  },
  {
    path: `/:unitName(${unitNameRex})/detail`,
    name: 'goodsDetail',
    component: () => import('../views/goods/detail.vue'),
  },
  {
    path: `/course/detail`,
    name: 'courseDetail',
    component: () => import('../views/course/detail.vue'),
    meta: { title: '精品课程分享' },
  },
  {
    path: `/course_series/detail`,
    name: 'goodsSeriesDetail',
    component: () => import('../views/goods/course-series.vue'),
  },

  {
    path: '/play/payment',
    name: 'playPayment',
    component: () => import('../views/pay/payment.vue'),
    meta: { title: '确认订单', requireAuth: true },
  },
  {
    path: '/pay/mp_payment',
    name: 'mpPayPayment',
    component: () => import('../views/pay/mpPayment.vue'),
    meta: { title: '支付详情' },
  },
  {
    path: '/pay/mp_middle_openid',
    name: 'mpPayPayment',
    component: () => import('../views/pay/mpMiddleOpenid.vue'),
    meta: { title: '支付详情' },
  },
  {
    path: '/pay/payment_success',
    name: 'playPaymentSuccess',
    component: () => import('../views/pay/paymentSuccess.vue'),
    meta: { title: '支付结果' },
  },
  {
    path: '/live/play',
    name: 'livePlay',
    component: () => import('../views/playing/live.vue'),
    meta: { title: '直播' },
  },
  {
    path: '/live/booking_form',
    name: 'liveBooking',
    component: () => import('../views/playing/liveBookingForm.vue'),
    meta: { title: '直播预约' },
  },
  {
    path: '/book/detail',
    name: 'bookDetail',
    component: () => import('../views/book/detail.vue'),
    meta: { title: '精品图书分享' },
  },
  {
    path: '/address/list',
    name: 'addressList',
    component: () => import('../views/address/list.vue'),
    meta: { title: '收货地址', requireAuth: true },
  },
  {
    path: '/address/edit',
    name: 'addressEdit',
    component: () => import('../views/address/edit.vue'),
    meta: { title: '地址编辑', requireAuth: true },
  },
  {
    path: '/estimate/report',
    name: 'estimateReport',
    component: () => import('../views/estimate/report.vue'),
    meta: { title: '估分报告' },
  },
  {
    path: '/estimate/list',
    name: 'estimateList',
    component: () => import('../views/estimate/estimateList.vue'),
    meta: { title: '在线估分' },
  },
  {
    path: '/estimate/reportPosition',
    name: 'estimateReportPosition',
    component: () => import('../views/estimate/reportPosition.vue'),
    meta: { title: '估分报告' },
  },
  {
    path: '/mp/middle',
    name: 'mpMiddle',
    component: () => import('../views/mp/middle.vue'),
    meta: { title: '小程序中间页' },
  },
  {
    path: '/collection/course',
    name: 'course',
    component: () => import('../views/collection/course.vue'),
    meta: { title: '课程合辑' },
  },
  {
    path: '/vod/play',
    name: 'course',
    component: () => import('../views/playing/vod.vue'),
    meta: { title: '视频回放' },
  },
  {
    path: '/shop/guide',
    name: 'guide',
    component: () => import('../views/shop/guide.vue'),
    meta: { title: '高端班导购' },
  },
  {
    path: '/download/store',
    name: 'store',
    component: () => import('../views/download/store.vue'),
    meta: { title: '图书商城' },
  },
  {
    path: '/course/compilation',
    name: 'compilation',
    component: () => import('../views/course/compilation.vue'),
    meta: { title: '合辑列表' },
  },
  {
    path: '/question/collection',
    name: 'questionCompilation',
    component: () => import('../views/question/collection.vue'),
    meta: { title: '合辑列表' },
  },
  {
    path: '/test/index',
    name: 'testIndex',
    component: () => import('../views/test/index.vue'),
    meta: { title: '测试路由' },
  },
]

export default routes
